﻿<script setup lang="ts">
    import { inject } from 'vue';
    import Loading from '@shared/components/Loading.vue';
    import MainNavigation from '@cwd/Navigation/MainNavigation.vue';
    import SignInModal from '@cwd/Account/SignIn/SignInModal.vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ContextAccess } from './Context.access';
    import { TranslationsAccess } from './Translations.access';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);
    const translationsAccess: TranslationsAccess = injectorAccess.injector.get(TranslationsAccess);

    const props = defineProps<{
        toggleSupportDialog: any;
        toggleChat: () => void;
        navCollapsed: boolean;
        startGuide: any;
    }>();

    function show(): boolean {
        return !translationsAccess.loading.value && !contextAccess.loading.value;
    }
</script>

<template>
    <div class="main-layout" :class="{ 'nav-collapsed': props.navCollapsed }">
        <div class="banner-evaluation-container"></div>
        <div class="main-navigation">
            <main-navigation
                v-if="show()"
                :toggleChat="props.toggleChat"
                :toggleSupportDialog="props.toggleSupportDialog"
                :navCollapsed="props.navCollapsed"
                :startGuide="props.startGuide"></main-navigation>
        </div>

        <Loading :show="contextAccess.loading.value || translationsAccess.loading.value" loadingStyle="progress-bar" :fixed="true"></Loading>

        <main class="main-content" v-if="show()">
            <SignInModal></SignInModal>

            <router-view />
        </main>
    </div>
</template>
<style></style>
